<template>
   <li class="p-2 mb-2 tree-item"
        @mouseover="hover = true"
        @click="selectItem"
        @mouseleave="hover = false"
        :class="{ 'hovered': hover, 'selected-item': item.selected }">

      <!-- Usa flex per allineare checkbox, icona e testo -->
      <div class="tree-item-header d-flex flex-align-center flex-justify-start"
          :title="item.name + ' [' + item.os_version + ']'">

        <input type="checkbox"
              v-model="item.selected"
              @change="updateSelection(item)">

        <span class="ml-2 d-flex flex-align-center">
          <svg width="20" height="20" fill="none" viewBox="3 3 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.75 2a.75.75 0 0 0-.75.75v18.5c0 .414.336.75.75.75H8V11.75a.75.75 0 0 1 1.5 0V22h8.75a.75.75 0 0 0 .75-.75V2.75a.75.75 0 0 0-.75-.75H5.75ZM9.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" fill="#212121"/></svg>
        </span>

        <span class="ml-2">{{ item.name }}</span>
      </div>

      <ul v-if="item.virtualHardDisks">
        <TreeDisk
          v-for="disk in item.virtualHardDisks"
          :key="disk.id"
          :disk="disk"
        />
      </ul>
    </li>
  </template>
  
  <script>
  import TreeDisk from './TreeDisk.vue';
  
  export default {
    components: { TreeDisk },
    props: {
      item: Object,
      hvselected: Object,
      selectedCount: Number,
    },
    data() {
        return {
            hover: false,
            //localSelectedCount: this.selectedCount,
        };
    },
    watch: {
    selectedCount(newVal) {
      //this.localSelectedCount = newVal; // Sync local property with prop
    }
  },
    methods: {
        selectItem() {
            //this.item.selected = !this.item.selected;
            this.$emit('update:hvselected', this.item);
        }, 
       updateSelection(item) {
        this.$emit('selectionChanged', item);
      }
    },
  };
  </script>
  
  <style scoped>
  .tree-item-header {
    
    align-items: left;
    cursor: pointer;
  }
  button {
    margin-left: auto;
    margin-right: 5px;
  }
  .tree-item {
  transition: background-color 0.3s ease;
}

.tree-item.hovered {
  background-color: #f0f0f0;
}
.tree-item.selected-item {
  background-color: #d3d3d3; /* Or any color you prefer */
}
  </style>
  